import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-overlay-loader',
  imports: [],
  templateUrl: './logo-overlay-loader.html',
  styleUrl: './logo-overlay-loader.scss',
})
export class LogoOverlayLoader {

}
